import { feedbackColorGreenPure, feedbackColorYellowPure, feedbackColorRedPure, feedbackColorOrangePure, feedbackColorPinkPure, feedbackColorPurplePure, feedbackColorBluePure, feedbackColorTurqPure } from '@deskfy/unify-design-tokens/jsvariables'

;(function () {
  'use strict'

  angular.module('deskfy.arts').controller('ShareSocialMediaController', ShareSocialMediaController)

  /* @ngInject */
  function ShareSocialMediaController (
    $scope,
    $timeout,
    $translate,
    CONSTANTS,
    UserService,
    Utils,
    ScheduleArtShareService,
    ToastService
  ) {
    $scope.maxMessageLength = 280
    $scope.clearMessageError = false

    $scope.socialMedia.medias = [
      {
        name: 'FACEBOOK',
        options: [],
        selected: [],
        allowed: true,
        allowedExtensions: ['JPEG', 'BMP', 'PNG', 'GIF', 'TIFF'],
        errorMessage: 'facebookFileTypeNotAllowed'
      },
      {
        name: 'TWITTER',
        options: [],
        selected: [],
        allowed: true,
        allowedExtensions: ['JPEG', 'PNG', 'GIF'],
        errorMessage: 'twitterFileTypeNotAllowed'
      },
      {
        name: 'LINKEDIN',
        options: [],
        selected: [],
        allowed: true,
        allowedExtensions: ['JPEG', 'PNG'],
        errorMessage: 'facebookFileTypeNotAllowed'
      }
    ]

    $scope.showMessageError = false

    let accounts = []

    const api = {
      _onChangeDropdownValue,
      _successGetSchedules
    }
    this.getApi = () => api

    activate()

    function activate () {
      ScheduleArtShareService.getSchedulesByArt($scope.art.id).then(api._successGetSchedules)

      UserService.getSocialAccounts().then(data => {
        accounts = data.filter(account => !(account.type === 'FACEBOOK' && account.principal))

        accounts.forEach(account => {
          const socialMediaIds = {
            FACEBOOK: 0,
            TWITTER: 1,
            LINKEDIN: 2
          }

          const media = $scope.socialMedia.medias[socialMediaIds[account.type]]
          if (!media) {
            return
          }

          if (
            $scope.art.customizationLevel === 'ONLY_DOWNLOAD' &&
            $scope.art.extension &&
            !media.allowedExtensions.includes($scope.art.extension.toUpperCase())
          ) {
            media.allowed = false
          }

          if (account.type === 'FACEBOOK') {
            account.profilePicture = Utils.fnReplaceStringParams(CONSTANTS.FACEBOOK_PROFILE_PIC_URL, [
              account.externalId
            ])
          }
          media.options.push(account)
        })

        $timeout(() => {
          $('.social-media-dropdown').dropdown({
            onChange: api._onChangeDropdownValue,
            message: {
              noResults: $translate.instant('noResults')
            },
            fullTextSearch: true
          })
        }, 100, false)
      })
    }

    const deregisterUpdatedScheduleArtPost = $scope.$on('updated-schedule-art-post', () => {
      ScheduleArtShareService.getSchedulesByArt($scope.art.id).then(api._successGetSchedules)
    })

    const deregisterShareSocialMediaClear = $scope.$on('share-social-media.clear', () => {
      $scope.socialMedia.message = ''
      $timeout(
        () => {
          $('.social-media-dropdown').dropdown('clear')
        },
        100,
        false
      )
    })

    $scope.$on('$destroy', () => {
      deregisterUpdatedScheduleArtPost()
      deregisterShareSocialMediaClear()
    })

    $scope.showDropdown = function () {
      $('.social-media-dropdown').dropdown('show')
    }

    $scope.onChangeMessage = (event) => {
      $scope.socialMedia.message = event.detail.value
      $scope.clearMessageError = $scope.socialMedia.message.length < $scope.maxMessageLength
      $scope.showMessageError = $scope.socialMedia.message.length === $scope.maxMessageLength
    }

    $scope.getMediaOptionInitials = (option) => {
      const names = option.name.split(' ')
      const initials = names[0][0] + names[names.length - 1][0]
      return initials.toUpperCase()
    }

    $scope.getAutoColor = (option) => {
      const COLORS_PALETTE = [feedbackColorGreenPure, feedbackColorYellowPure, feedbackColorRedPure, feedbackColorOrangePure, feedbackColorPinkPure, feedbackColorPurplePure, feedbackColorBluePure, feedbackColorTurqPure]

      const lon = option.name.length

      let charIndex = 0

      for (let i = 0; i < lon; i++) charIndex = option.name.charCodeAt(i)
      const colorIndex = charIndex % COLORS_PALETTE.length
      return COLORS_PALETTE[colorIndex]
    }

    function _successGetSchedules (data) {
      if (data.length) {
        $scope.schedule = data[0]
        $scope.socialMedia.message = data[0].message
        $scope.socialMedia.selected = data[0].socialAccounts
        const accounts = data[0].socialAccounts.map(account => account.externalId)

        $timeout(
          () => {
            $('.social-media-dropdown').dropdown('set selected', accounts)
          },
          100,
          false
        )
      } else {
        $scope.schedule = ''
      }
    }

    function _onChangeDropdownValue (values, text) {
      $scope.socialMedia.medias[0].selected = []
      $scope.socialMedia.medias[1].selected = []
      $scope.socialMedia.medias[2].selected = []

      const arrayValues = values.split(',')
      $scope.socialMedia.selected = []

      const socialMediaIds = {
        FACEBOOK: 0,
        TWITTER: 1,
        LINKEDIN: 2
      }

      arrayValues.forEach(value => {
        const selectedAccount = accounts.find(account => account.externalId === value)
        if (!selectedAccount || socialMediaIds[selectedAccount.type] === undefined) {
          return
        }

        const media = $scope.socialMedia.medias[socialMediaIds[selectedAccount.type]]
        if (!media) {
          return
        }

        if (media.allowed) {
          media.selected.push(selectedAccount)
          if (value) {
            $scope.socialMedia.selected.push(value)
          }
        } else {
          ToastService.showErrorToast(media.errorMessage)
          $timeout(
            () => {
              $('.social-media-dropdown').dropdown('remove selected', value)
            },
            100,
            false
          )
        }
      })
    }
  }
})()
